import React from 'react';
import './ProgrammeBodyElement.css';
import { renderDateAndTimeToRecentPhrase } from '../library/DateTimeFuncs.js';

// Helper function to map subIconText values to safe CSS class names
const getStatusClassName = (statusText) => {
  switch (statusText) {
    case "Cancelled":
      return "status-cancelled";
    case "Enrolling":
      return "status-enrolling";
    case "Waitlisting":
      return "status-waitlisting";
    case "Not open for applications":
      return "status-closed";
    default:
      return "";
  }
};

// render the programme body element
const ProgrammeBodyElement = (props) => {
  const dateAndTime = props.dateAndTime === undefined ? undefined : props.dateAndTime;
  const dateAndTimePrefix = props.dateAndTimePrefix === undefined ? "" : props.dateAndTimePrefix;
  const headerClassName = props.className === undefined ? "row-header" : "row-header " + props.className;
  const icon = props.icon;
  const hasDateAndTime = dateAndTime !== undefined && Object.prototype.toString.call(dateAndTime) === '[object Date]' && dateAndTime.getFullYear() >= 2022;
  const hasIcon = icon !== undefined;
  const iconAlt = props.iconAlt === undefined ? "" : props.iconAlt;
  const isVisible = props.visible === undefined ? true : props.visible;
  const title = props.title;
  const text = props.text;
  const textColor = props.textColor === undefined ? undefined : props.textColor;
  const subText = props.subText === undefined ? "" : props.subText;
  const subIcon = props.subIcon === undefined ? undefined : props.subIcon;
  const subIconText = props.subIconText === undefined ? "" : props.subIconText;

  // quick exit if the element is invisible
  if (!isVisible)
    return (<></>);

  // Get the safe CSS class based on the text value
  const statusClass = getStatusClassName(subIconText);
  const subIconTextClass = subIconText.length
    ? `ProgrammeBodyElement-subtext ${statusClass}`
    : "ProgrammeBodyElement-subtext";

  // render icon
  const iconContent = hasIcon
    ? <><div className="ProgrammeBodyElement-icon"><img src={icon} width="16" height="16" alt={iconAlt} /></div></>
    : <></>;

  // render subIcon using CSS mask so its colour can be controlled dynamically
  const subIconContent = subIcon
    ? <div
      className={`ProgrammeBodyElement-subicon ${statusClass}`}
      style={{
        WebkitMaskImage: `url(${subIcon})`,
        maskImage: `url(${subIcon})`
      }}
      role="img"
      aria-label={subIconText}
    />
    : <></>;

  // render date and time
  const dateAndTimeContent = hasDateAndTime
    ? <><span className="ProgrammeBodyElement-subtext">{dateAndTimePrefix}{renderDateAndTimeToRecentPhrase(dateAndTime, dateAndTimePrefix.length === 0)}</span></>
    : <></>;

  const subTextContent = subText.length
    ? <><span className="ProgrammeBodyElement-subtext">{subText}</span></>
    : <></>;

  const subIconTextContent = subIconText.length
    ? <><span className={subIconTextClass}>{subIconText}</span></>
    : <></>;

  // render text
  const textFragment = textColor === undefined
    ? text
    : <span className={textColor}>{text}</span>;
  const textContent = <><div className="ProgrammeBodyElement-text">{textFragment}{subTextContent}{dateAndTimeContent}</div></>;

  // render the element
  return (<>
    <div className="app-wrapper body-wrapper">
      <div className={headerClassName} >{title}</div>
      <div className="row-wrapper">
        <div className="row-content">{iconContent}{textContent}</div>
        <div className="row-content">{subIconContent}{subIconTextContent}</div>
      </div>
    </div>
  </>);
}

export default ProgrammeBodyElement;